/********************************************
 * Network Diagram
 ********************************************/
function fnNetworkDiagram(i, oSection) {

    var oSection = $(oSection),
        oDiagram = $('svg#diagram', oSection);

    oSection.find('svg.anim-circle-2').click(function (ev) {
        ev.preventDefault();
        fnRandValues('left');
        oDiagram.addClass('left-active');
        setTimeout(function () {
            oDiagram.removeClass('left-active');
        }, 1500);
    });
    oSection.find('svg.anim-circle-3').click(function (ev) {
        ev.preventDefault();
        fnRandValues('right');
        oDiagram.addClass('right-active');
        setTimeout(function () {
            oDiagram.removeClass('right-active');
        }, 1500);
    });

    function fnRandValues(sSide) {
        $("svg#diagram path[id*='"+ sSide +"']").each(function () {
            $(this).attr('style','--random:' + Math.random() + '');
        });
    }

}


// END OF DOCUMENT
